<div class="sms-campaign-success-page">
  <div class="success-page-live-preview">
    <div class="success-state-message" *ngIf="loading">
      <div class="state-spinner"></div>
      <p>Loading...</p>
    </div>

    <div class="success-state-message success-state-error" *ngIf="!loading && error">
      <p>{{ error }}</p>
    </div>

    <div class="success-live-card" *ngIf="!loading && !error">
      <div class="success-live-logo" [class.has-image]="!!getSuccessPreviewLogo()">
        <img
          *ngIf="getSuccessPreviewLogo()"
          [src]="getSuccessPreviewLogo()"
          alt="Success page logo"
        />
        <span *ngIf="!getSuccessPreviewLogo()">Logo</span>
      </div>
      <h5 class="success-live-title">{{ getSuccessPreviewText(successPage.title) }}</h5>
      <p class="success-live-body">{{ getSuccessPreviewText(successPage.body) }}</p>
      <button
        *ngIf="shouldShowCta()"
        type="button"
        class="success-live-cta"
        [style.backgroundColor]="successPage.ctaColor"
        (click)="onCtaClick()"
      >
        {{ successPage.ctaText || 'Visit our website' }}
      </button>
      <div class="success-live-resend" *ngIf="successPage.showResend">
        <span class="success-live-resend-status">{{ getSuccessResendStatusText() }}</span>
        <button
          type="button"
          class="success-live-resend-link"
          [disabled]="!canResend()"
          (click)="onResend()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M2.33333 7C2.33333 4.42267 4.42267 2.33333 7 2.33333C8.41421 2.33333 9.68571 2.905 10.5858 3.805M11.6667 7C11.6667 9.57733 9.57733 11.6667 7 11.6667C5.58579 11.6667 4.31429 11.095 3.41421 10.195M2.33333 2.33333V5.66667H5.66667M8.33333 11.6667V8.33333H11.6667"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {{ resending ? 'Sending...' : 'Resend' }}
        </button>
      </div>

      <p class="success-live-resend-feedback" *ngIf="successPage.showResend && resendMessage">
        {{ resendMessage }}
      </p>
      <p
        class="success-live-resend-feedback success-live-resend-feedback-error"
        *ngIf="successPage.showResend && resendError"
      >
        {{ resendError }}
      </p>
    </div>
  </div>
</div>
